import { IdpType } from '@shared/enums/IdpType';
import { ActivityTimeRange, IActivityLogBase } from '@shared/services/activity-service/activity.models';

export class ActivityFilter {
    constructor(public timeRange: ActivityTimeRange, public category: ActivityCategory = null, public userId: string = null) { }
  }

export enum ActivityCategory {
    Created = 0,
    Updated = 1,
    Deleted = 2,
    Account = 3
}

export interface IActivityLog extends IActivityLogBase {
  userName2: string;
  roleName: string;
  clientId: string;
  idpType: IdpType;
}

export interface IActivityLogs {
    activities: IActivityLog[];
}
